// Timestamp + delivery state, rendered as a small line *below* a message
// (outside the bubble) — `right` for user turns, `left` for assistant turns.

import { CheckIcon, RetryIcon } from '../ui/Icons';
import { Spinner } from '../ui/Spinner';

function formatTime(ts: number | undefined): string {
  if (!ts) return '';
  return new Date(ts).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
}

interface Props {
  timestamp?: number | undefined;
  status?: 'sending' | 'sent' | 'failed';
  align: 'left' | 'right';
  onRetry?: () => void;
}

export function MessageMeta({ timestamp, status, align, onRetry }: Props) {
  const time = formatTime(timestamp);
  if (!time && !status) return null;
  return (
    <div
      className={`mt-1 flex items-center gap-1 px-1 text-[10px] text-text-faint ${
        align === 'right' ? 'justify-end' : 'justify-start'
      }`}
    >
      <span>{time}</span>
      {status === 'sending' && <Spinner size={9} />}
      {status === 'sent' && <CheckIcon size={10} />}
      {status === 'failed' && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-0.5 text-error-text hover:underline"
          title="Retry"
        >
          <RetryIcon size={10} /> retry
        </button>
      )}
    </div>
  );
}
